module.exports = __webpack_public_path__ + "static/img/introduction-welcome-digitization.68efbf6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/introduction/introduction-welcome-digitization.jpg
// module id = vMf+
// module chunks = 0